const WantToExpand = {
    'Nationwide': 'Nationwide',
    'International': 'International',
};

export default Object.keys(WantToExpand).map(value => ({
    value,
    label: WantToExpand[value]
}));
